import { getLocalStorageData } from '../../utils/helper';
import { APP_API_URL, APP_API_URL_V2 } from '../../utils/xhr-instance';
import axiosInstance, { axiosInstanceV2 } from '../axios';

export const VENDOR_LIST_DONE = 'VENDOR_LIST_DONE';
export const VENDOR_LIST_FAIL = 'VENDOR_LIST_FAIL';

export const VENDOR_BANK_DETAILS_CREATE_DONE = 'VENDOR_BANK_DETAILS_CREATE_DONE';
export const VENDOR_BANK_DETAILS_CREATE_FAIL = 'VENDOR_BANK_DETAILS_CREATE_FAIL';

export const VENDOR_BANK_DETAILS_GET_DONE = 'VENDOR_BANK_DETAILS_GET_DONE';
export const VENDOR_BANK_DETAILS_GET_FAIL = 'VENDOR_BANK_DETAILS_GET_FAIL';

export const VENDOR_BANK_DETAILS_DELETE_DONE = 'VENDOR_BANK_DETAILS_DELETE_DONE';
export const VENDOR_BANK_DETAILS_DELETE_FAIL = 'VENDOR_BANK_DETAILS_DELETE_FAIL';

export const VENDOR_BANK_DETAILS_UPDATE_DONE = 'VENDOR_BANK_DETAILS_UPDATE_DONE';
export const VENDOR_BANK_DETAILS_UPDATE_FAIL = 'VENDOR_BANK_DETAILS_UPDATE_FAIL';

export const VENDOR_CONTACT_PERSON_CREATE_DONE = 'VENDOR_CONTACT_PERSON_CREATE_DONE';
export const VENDOR_CONTACT_PERSON_CREATE_FAIL = 'VENDOR_BANK_DETAILS_CREATE_FAIL';

export const VENDOR_CONTACT_PERSON_GET_DONE = 'VENDOR_CONTACT_PERSON_GET_DONE';
export const VENDOR_CONTACT_PERSON_GET_FAIL = 'VENDOR_BANK_DETAILS_GET_FAIL';

export const VENDOR_CONTACT_PERSON_DELETE_DONE = 'VENDOR_CONTACT_PERSON_DELETE_DONE';
export const VENDOR_CONTACT_PERSON_DELETE_FAIL = 'VENDOR_BANK_DETAILS_DELETE_FAIL';

export const VENDOR_CONTACT_PERSON_UPDATE_DONE = 'VENDOR_CONTACT_PERSON_UPDATE_DONE';
export const VENDOR_CONTACT_PERSON_UPDATE_FAIL = 'VENDOR_CONTACT_PERSON_UPDATE_FAIL';

export const CHANGE_STATUS_DONE = 'CHANGE_STATUS_DONE';
export const CHANGE_STATUS_FAIL = 'CHANGE_STATUS_FAIL';

export const CREATE_VENDOR_API_URL = `${APP_API_URL}/vendor/create-vendor`;
export const UPDATE_VENDOR_API_URL = `${APP_API_URL}/vendor/update-vendor`;
export const GET_PAYMENT_TERMS_MASTER = `${APP_API_URL}/vendor/get-payment-terms-master`;
export const GET_VENDOR_LIST = `${APP_API_URL}/vendor/get-vendor`;

export const VENDOR_CONTACT_PERSON_API_URL = `${APP_API_URL}/vendor/vendor-contact-person`;
export const VENDOR_BANK_DETAILS_API_URL = `${APP_API_URL}/vendor/vendor-bank-details`;
export const VENDOR_PAYMET_TERM_CREATE_API_URL = `${APP_API_URL}/vendor/create-vendor`;
export const CHANGE_STATUS_API_URL = `${APP_API_URL}/vendor/update-status`;
export const CREATE_PAYMENT_TERMS_API_URL = `${APP_API_URL}/vendor/create-payment-terms`;
export const GET_PAYMENT_TERMS = `${APP_API_URL}/vendor/get-payment-terms`;
export const UPDATE_CURRENCY_OR_PAYMENT_TERMS = `${APP_API_URL}/vendor/update-currency-payment-terms`;
export const REUPLOAD_VENDOR_DOCUMENT = `${APP_API_URL}/vendor/reupload-document`;
export const UPLOAD_VENDOR_DOCUMENT = `${APP_API_URL}/vendor/create-document`;
export const GET_CITIES = `${APP_API_URL}/app/get-city`;

export async function fetchVendors(params) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstance.get(`${APP_API_URL}/vendor/get-vendor`, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});

		return data.data;
	} catch (error) {
		throw error;
	}
}

export async function getVendors(params) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstanceV2.get(`${APP_API_URL_V2}/purchase/vendors/list`, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});

		return data.data;
	} catch (error) {
		throw error;
	}
}

export async function getVendorDetails(id) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstanceV2.get(`${APP_API_URL_V2}/purchase/vendors/details/${id}`, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});

		return data.data;
	} catch (error) {
		throw error;
	}
}

export async function deleteVendorService(vendor_ids) {
	const token = localStorage.getItem('authToken');
	try {
		await axiosInstance.post(
			`${APP_API_URL}/vendor/delete-vendor`,
			{
				vendor_ids,
			},
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);
	} catch (error) {
		throw error;
	}
}

export const changeIsActiveStatus = async (body) => {
	try {
		let API_URL = CHANGE_STATUS_API_URL;
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.put(API_URL, body, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});
		return data?.data;
	} catch (error) {
		throw error;
	}
};

export const getCities = async (body) => {
	try {
		let API_URL = GET_CITIES;
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.post(API_URL, body, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});
		return data;
	} catch (error) {
		throw error;
	}
};

export async function getStates() {
	const API_URL = `${APP_API_URL}/app/states`;
	const token = getLocalStorageData();
	return await axiosInstance
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => {
			return res.data.data;
		})
		.catch((error) => {
			return error.response?.data;
		});
}

export async function getIndustries() {
	const API_URL = `${APP_API_URL}/app/industry`;
	const token = getLocalStorageData();
	return await axiosInstance
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => {
			return res.data.data;
		})
		.catch((error) => {
			return error.response?.data;
		});
}

export const fetchPaymentTerm = async (params) => {
	try {
		const API_URL = GET_PAYMENT_TERMS;
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.get(API_URL, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});
		return data?.data;
	} catch (error) {
		throw error;
	}
};

export async function createPaymentTerm(paymentTerm) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.post(
			`${APP_API_URL}/vendor/create-payment-terms`,
			{ term_name: paymentTerm },
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data;
	} catch (error) {
		throw error;
	}
}

export async function deleteBankDetails(vendor_id, bank_details_id) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.delete(
			`${APP_API_URL}/vendor/vendor-bank-details/${vendor_id}`,
			{
				data: { bank_details_id },
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data;
	} catch (error) {
		throw error;
	}
}

export async function deleteVendorDocument(vendorDocumentId, docName) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.delete(
			`${APP_API_URL}/vendor/delete-document/${vendorDocumentId}?documentKey=${docName}`,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data;
	} catch (error) {
		throw error;
	}
}

export async function addVendorContactPerson(body, vendor_id) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.post(
			`${APP_API_URL}/vendor/vendor-contact-person/${vendor_id}`,
			body,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data;
	} catch (error) {
		throw error;
	}
}

export const updateVendorContactPerson = async (vendorId, contactPersonId, body) => {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.put(
			`${APP_API_URL}/vendor/vendor-contact-person` +
				`/${vendorId}?contact_person_id=${contactPersonId}`,
			body,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data;
	} catch (error) {
		throw error;
	}
};

export async function addNewVendor(body) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.post(`${APP_API_URL}/vendor/create-vendor`, body, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw error;
	}
}

export async function exportVendorTableData(ids) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.get(`${APP_API_URL}/vendor/export`, {
			params: { vendor_ids: ids },
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			responseType: 'blob',
		});

		const blob = new Blob([data], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		});
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = 'vendor_table.xlsx';
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);

		setTimeout(() => window.URL.revokeObjectURL(url), 1000);
	} catch (error) {
		console.error('Error exporting vendor data:', error);
		throw error;
	}
}
